<div
  [class.has-filters]="showFilters()"
  class="__host"
  [style.height]="scrollHeight()">
  @if (showFilters()) {
  <div class="__filters">
    <!-- container filter -->
    @if (containers()) {
    <div class="__filter-item">
      <button
        (click)="containerPopRef.open()"
        [satPopoverAnchor]="containerPopRef"
        mat-flat-button
        class="c-button--smaller __filter-button"
      >
        <mat-icon
          class="fx:align-middle __filter-item_icon"
          fontSet="material-icons-outlined"
          >dns</mat-icon
        >
        <span>{{ containerMap()?.[containerId()]?.hostname }}</span>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>

      <sat-popover
        #containerPopRef
        [autoFocus]="false"
        [restoreFocus]="false"
        hasBackdrop
        (backdropClicked)="containerPopRef.close()"
        [verticalAlign]="'below'"
        [horizontalAlign]="'center'"
      >
        <mat-card class="__filter-pop-card z-manual-elevation c-soft-elevation">
          <zef-scrollbar>
            <mat-action-list class="__filter-action-list fx:pb-0-25" dense>
              @for (item of containers(); track $index) {
              <button
                class="__filter-option"
                (click)="filterChange.emit({ containerId: item.id }); containerPopRef.close();"
                [class.is-active]="containerId() === item.id"
                mat-list-item
                type="button"
              >
                <zui-action-list-item
                  [mode]="'dense'"
                  [label]="item.hostname"
                />
              </button>
              }
            </mat-action-list>
          </zef-scrollbar>
        </mat-card>
      </sat-popover>
    </div>
    }

    <div class="__filter-item">
      @if (isContainerInactive()) {
      <div>
        <span class="__status __status--inactive"></span>
        <span class="__status-text">Container not running</span>
      </div>
      } @else if (isUnauthorized()) {
      <div>
        <span class="__status __status--inactive"></span>
        <span class="__status-text">Access denied</span>

        <button
          (click)="reconnect()"
          class="__reconnect-button c-button--smaller"
          mat-button
        >
          <mat-icon>replay</mat-icon>
          Try again
        </button>
      </div>
      } @else if (isConnected()) {
      <div>
        <span class="__status __status--active"></span>
        <span class="__status-text">Connected</span>
      </div>
      } @else {
      <div>
        <span class="__status __status--inactive"></span>
        <span class="__status-text">
          {{ isConnecting() ? 'Connecting' : 'Disconnected' }}
        </span>

        @if (canReconnect()) {
        <button
          (click)="reconnect()"
          class="__reconnect-button c-button--smaller"
          mat-button
        >
          <mat-icon>replay</mat-icon>
          Reconnect
        </button>
        }
      </div>
      }
    </div>
  </div>
  }

  <ng-terminal />
</div>
